"use client";

import { c as _c } from "react/compiler-runtime";
import { clsx } from "@/helpers/clsx";
import { AtSymbolIcon } from "@heroicons/react/20/solid";
export const EmailLink = t0 => {
  const $ = _c(7);
  const {
    className,
    children
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = clsx("inline-flex cursor-pointer flex-row items-center font-sans text-neutral-200 !decoration-primary-400 hover:underline-offset-[6px]", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children) {
    t2 = !!children ? children : <>hello<AtSymbolIcon className="h-[18px] w-[18px]" />fundra.com</>;
    $[2] = children;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <a href="#" className={t1} onClick={_temp}>{t2}</a>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
function _temp(e) {
  e.preventDefault();
  window.open("mailto:hello@fundra.com", "_blank");
}